import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, putApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { AtualizarParametroLocalidadeDetalheRequest, Types } from './types';

// ACTIONS
import {
	atualizarParametroLocalidadeDetalheSuccess,
	atualizarParametroLocalidadeDetalheFailure,
} from './actions';

function* atualizarParametrosLocalidade(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: AtualizarParametroLocalidadeDetalheRequest } =
		request;

	const body = {
		descricao: payload.descricao,
		valor: payload.valor,
		idLocalidade: payload.idLocalidade,
	};

	const response: ApiResponse = yield call(
		putApi,
		token || '',
		PATH_SGU_API,
		`v2/parametros-localidades/${payload.sigla}/localidades`,
		body,
	);

	if (response.status === 200) {
		yield put(atualizarParametroLocalidadeDetalheSuccess(response));
	} else {
		yield put(atualizarParametroLocalidadeDetalheFailure());
	}
}

export default all([
	takeLatest(
		Types.ATUALIZAR_PARAMETRO_LOCALIDADE_DETALHE,
		atualizarParametrosLocalidade,
	),
]);
